import { Pill, type PillProps, crossIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { VisuallyHidden } from "@repo/ui/src/components/VisuallyHidden";

export const SelectedFilterPill = ({ label, ...props }: PillProps) => {
  return (
    <Pill
      size="small"
      selected
      label={
        <>
          <VisuallyHidden>{t("label.remove_search_filter")}</VisuallyHidden>
          {label}
        </>
      }
      leadingIcon={crossIcon}
      {...props}
    />
  );
};
